__turbopack_context__.v({
  "bar": "TgQSfW_bar",
});
